/**
 * Shared helpers for building tour step lists from live DOM state.
 */

export const elementExists = (selector) => {
  if (typeof document === 'undefined') {
    return false;
  }

  const element = document.querySelector(selector);
  return element !== null && element.offsetParent !== null;
};

export const filterExistingSteps = (steps) =>
  steps.filter((step) => elementExists(step.selector));
